import * as actions from './retailers.action';
import reducer from './retailers.reducer';

export default {
  actions,
  reducer,
};
